/**
 * @generated SignedSource<<7d41b25daf7657eabd19be9df42555dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "SbRespInteriorsPhotoCarousel_user";
};
export type SbRespInteriorsPhotoCarousel_user$key = {
  readonly " $data"?: SbRespInteriorsPhotoCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsPhotoCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9486304afdd45dc5271eadc234e5779d";

export default node;
